import { render, staticRenderFns } from "./limitNumUsers.vue?vue&type=template&id=156fc45d&scoped=true"
import script from "./limitNumUsers.vue?vue&type=script&lang=js"
export * from "./limitNumUsers.vue?vue&type=script&lang=js"
import style0 from "./limitNumUsers.vue?vue&type=style&index=0&id=156fc45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156fc45d",
  null
  
)

export default component.exports